/**
 * 프로그래밍적 포커스 이동 유틸리티.
 * 포커스 시 'programmatic-focus' 클래스를 부여하여 CSS로 포커스 링을 숨김.
 * blur 시 클래스를 제거하여, VoiceOver/TalkBack 등 스크린리더가
 * 직접 포커스할 때는 포커스 링이 정상 표시됨.
 */
export function programmaticFocus(el: HTMLElement | null) {
  if (!el) return
  el.classList.add("programmatic-focus")
  el.focus()
  const cleanup = () => {
    el.classList.remove("programmatic-focus")
    el.removeEventListener("blur", cleanup)
  }
  el.addEventListener("blur", cleanup)
}
  